module.exports = __webpack_public_path__ + "static/media/tenancy-web.84ff25be.png";